import React from "react";
import styles from "../../_css/SearchInputTable.module.css";
import { Search } from "lucide-react";

const SearchInputTable = ({
  value,
  onChange,
  placeholder,
  column = null,
  width = "220px",
  paddingContainer = "0",
  padding = "4px 12px",
}) => {
  return (
    <div style={{ padding: paddingContainer }} className={styles.searchContainer}>
      <input
        type="text"
        className={styles.tableSearchInput}
        value={value}
        onChange={(e) => onChange(e.target.value, column)}
        placeholder={placeholder}
        autoComplete="off"
        style={{
          width,
          padding,
        }}
      />
      <Search size={16} className={styles.searchIcon} />
    </div>
  );
};

export default SearchInputTable;
